import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBed: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bed"><path d="M2.75 10.75H21.25V17.25H2.75V10.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.25 10.5V4.75H4.75V10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 4.75V10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4.75 17.25V19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.25 17.25V19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBed;
